import React from 'react';

import Skeleton from '@material-ui/lab/Skeleton';

import styles from './style.module.scss';

const ClassroomStatusesSkeleton = () => (
  <div className={styles.container}>
    <Skeleton variant="rect" width={80} height={100} />
    <Skeleton variant="rect" width={80} height={100} />
    <Skeleton variant="rect" width={80} height={100} />
    <Skeleton variant="rect" width={80} height={100} />
  </div>
);

export default ClassroomStatusesSkeleton;
